import { VcenterNirvanaDataProvider } from '../dataProvider/VcenterNirvanaDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../../webcomponents.constants';

export class VcenterDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, VcenterNirvanaDataProvider);
  }
}
